import { appPath } from '@featit/shared/addressing/paths';

/** T-0318: the address the iPhone app boots its warm spare web view on (`ShellSpareScreen`). */
export const SHELL_SPARE_PATH = appPath('/shell-spare');

/**
 * I-1578 (RD-40, `docs/concept-mobile-app.md`): whether this web view is the hidden spare. The spare
 * is no tab and shows no scope, so it reads nothing for one: what it read before followed its own
 * stale copy of the scope (All, then the first work area, then All at a launch on All; the old work
 * area three times on a resume after a pick). Taken by a tab, it is routed to that tab's address
 * and reads for the app's scope there.
 */
export function isShellSpare(pathname: string): boolean {
  return pathname === SHELL_SPARE_PATH;
}
